import React from 'react'
import { Heading, Text } from 'base-ui'
import {Menu as MenuExample } from '../examples/Menu'
import CodeSampleSelector from './CodeSampleSelector'
import { Menu } from '@headlessui/react'
import { PageWrapper } from './PageWrapper'

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}

const NewMenu = () => {
  return (
    <PageWrapper title="Menu">
      <Text size="lg">A Menu offers a list of actions or functions that a user can access. </Text>
      <div className="py-4">
        <Menu as="div" className="relative inline-block text-left z-10">
            <Menu.Button className="bg-white hover:bg-gray-800 text-gray-900 hover:text-white border-gray-900 ring-gray-900 font-bold text-center rounded align-middle focus:outline-none border focus:ring-offset-2 focus:ring-2 h-10 overflow-hidden px-4 uppercase">
              Options
            </Menu.Button>
            <Menu.Items className="origin-top-right absolute left-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
              <div className="py-1">
                <Menu.Item>
                  {({ active }) => (
                    <a
                      href="#"
                      className={classNames(
                        active ? 'bg-primary text-white' : 'text-gray-900',
                        'block px-4 py-2 text-sm'
                      )}
                    >
                      Option
                    </a>
                  )}
                </Menu.Item>
                <form method="POST" action="#">
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        type="submit"
                        className={classNames(
                          active ? 'bg-primary text-white' : 'text-gray-900',
                          'block w-full text-left px-4 py-2 text-sm'
                        )}
                      >
                        Sign out
                      </button>
                    )}
                  </Menu.Item>
                </form>
              </div>
            </Menu.Items>
        </Menu>
      </div>
      <Heading size="h3">Usage</Heading>
      <CodeSampleSelector
        baseUi={`TBD`}
        algoliaUi={`TBD`}
        headlessUi={MenuExample}
      />
    </PageWrapper>
  )
}

export default NewMenu